import { FC } from 'react'
import { BitazzaText } from '../../../../components'
import Style from './Header.module.scss'

interface Props {
    title: string
    subTitle?: string
}

export const Header: FC<Props> = ({ title, subTitle }) => {
    return (
        <div className={Style.runningContainer}>
            <BitazzaText
                content={title}
                format="t28"
                color="#F1D87E"
                letterSpacing={2}
                bold
            />
            {subTitle && (
                <BitazzaText
                    content={subTitle}
                    format="t28"
                    color="#FFF"
                    letterSpacing={2}
                    textAlign="center"
                />
            )}
        </div>
    )
}
